<nz-modal
  [nzWidth]="'800px'"
  [(nzVisible)]="isVisible"
  (nzVisibleChange)="onIsVisibleChange($event)"
  [nzTitle]="'Generate Customer Profile'"
  (nzOnCancel)="onCancelClick()"
  [nzOkText]="'Generate'"
  (nzOnOk)="onGenerateClick()"
  [nzOkLoading]="isLoading()"
  [nzCancelText]="'Cancel'"
  [nzCancelLoading]="isLoading()"
>
  <ng-container *nzModalContent>
    <div class="vertical-large content">
      <div class="vertical">
        @if (!isLoading()) {
          <nz-radio-group [(ngModel)]="resumeType" nzButtonStyle="solid">
            <label nz-radio-button [nzValue]="ResumeType.real">Real Customer</label>
            <label nz-radio-button [nzValue]="ResumeType.ai">AI Customer</label>
          </nz-radio-group>

          <textarea
            nz-input
            placeholder="Automatically generate customer profile from the provided text."
            [(ngModel)]="customerInfo"
            [nzAutosize]="{ minRows: 10, maxRows: 20 }"
          ></textarea>
        } @else {
          <nz-skeleton [nzActive]="true"></nz-skeleton>
        }
      </div>
    </div>
  </ng-container>
</nz-modal>
